import React, {useEffect, useState} from 'react';
import {useNavigate, useSearchParams} from "react-router-dom";
import Template from "../../layouts/Template";
import DialogAlert from "../../components/DialogAlert";
import imageLogo from "../../assets/images/cartracker-logo-1.png";
import './index.scss';
import IndexedDb from "../../database/indexedDb";
import {tableNames} from "../../database/interfaceDb";
import helpers from "../../utils/helpers";

//**********************************************************

let indexedDb: IndexedDb;

//**********************************************************

function Index()
{
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    const dialogAlert = React.createRef<any>();
    const [dialogAlertType, setDialogAlertType] = useState<string>('');
    const [dialogAlertTitle, setDialogAlertTitle] = useState<string>('');
    const [dialogAlertDes, setDialogAlertDes] = useState<string>('');

    // create indexedDb object
    const initDB = async () =>
    {
        indexedDb = new IndexedDb();
        await indexedDb.createObjectStore().then
        (
            r =>
            {
                if(r)
                {
                    // check server selected
                    checkTableServer().then(hasServer =>
                    {
                        setTimeout(() => { navigate(hasServer ? "/login" : "/server"); }, 2000);
                    });
                }
                else
                {
                    setDialogAlertTitle("");
                    setDialogAlertDes("مشکلی در آماده سازی نرم افزار پیش آمده است.");
                    setDialogAlertType("error");
                    dialogAlert.current.show();
                }
            }
        );
    };
    useEffect
    (() =>
        {
            if(searchParams.has("mobile"))
            {
                checkDevice(searchParams.get("mobile"))
            }
            else
            {
                initDB();
            }
        },
        []
    );

    // check server selected
    const checkTableServer = async () =>
    {
        const servers = await indexedDb.getAllValue(tableNames.Servers);
        return (servers.length > 0);
    };

    // check device with mobile
    const checkDevice = async (mobile: string | null) =>
    {
        if(window.hasOwnProperty("AndroidFunction") && mobile != null)
        {
            mobile = helpers.initMobile(mobile);

            indexedDb = new IndexedDb();
            indexedDb.open().then(r =>
            {
                indexedDb.getAllValue(tableNames.Devices).then
                (
                    data =>
                    {
                        if(data != null && data.length > 0)
                        {
                            for (let i = 0; i < data.length; i++)
                            {
                                if(data[i].mobile === mobile)
                                {
                                    // @ts-ignore
                                    window.AndroidFunction.showDeviceName(data[i].carName);
                                    break;
                                }
                            }
                        }
                    }
                );
            });
        }
    };

    //--------------------
    return (
        <Template pageClass="page-splash" showHeader={false} showFooter={false}>
            <img className="logo" src={imageLogo} alt=""/>
            <div className="title">نرم افزار ردیابی خودرو IRANGPS</div>

            <DialogAlert ref={dialogAlert} title={dialogAlertTitle} des={dialogAlertDes} type={dialogAlertType} isClose={false} />
        </Template>
    );
}

export default Index;
